/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import DynamicButton from '../Buttons/DynamicButton';

function AccessNewRoleButton({ roleData, action }) {
  const [temp, setTemp] = useState('');

  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const handlePopUp = () => {
    setTemp('');
    onOpen();
  };

  const handleChange = (input) => {
    const regex = /^[A-Za-z\s-]+$/;
    if (!regex.test(input) && input !== '') return;
    setTemp(input.toLowerCase().replace(/\s+/g, '-'));
  }
  
  const handleAdd = async () => {
    if (!temp) {
      toast({
        title: 'Nama role tidak boleh kosong',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    const similar = roleData?.find((x) => x?.title === temp);
    if (similar) {
      toast({
        title: 'Nama role harus unik',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    if (temp === 'owner' || temp === 'users') {
      toast({
        title: 'Nama role dilarang',
        status: 'error',
        duration: 3000,
      });
      return;
    }

    try {
      await action(temp, [], false);
      onClose();
      toast({
        title: 'Role berhasil dibuat',
        status: 'success',
        duration: 3000,
      });
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return (
    <>
      <DynamicButton action="create" title="New Role" variant="solid" onClick={handlePopUp} />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Tambah Role Baru</ModalHeader>
          <ModalBody>
            <FormControl>
              <FormLabel>Nama Role</FormLabel>
              <Input variant="filled" placeholder="contoh: manager" value={temp} onChange={(e) => handleChange(e.target.value)} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Batal
            </Button>
            <Button colorScheme="green" onClick={handleAdd}>
              Tambah
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default AccessNewRoleButton;
